/**
 * 公司品牌 Logo
 *
 * 仅引用 public/logos 下的本地静态资源（单色标跟随 SVG 内默认色，彩色标保留官方配色）；
 * 未知公司回退为首字母圆标，避免出现破图。
 */

const COMPANY_LOGO_SOURCES: Record<string, string> = {
  bytedance: '/logos/bytedance.svg',
  alibaba: '/logos/alibaba.svg',
  google: '/logos/google.svg',
  openai: '/logos/openai.svg',
  xai: '/logos/xai.svg',
  minimax: '/logos/minimax.svg',
  kuaishou: '/logos/kuaishou.svg',
};

interface CompanyLogoProps {
  companyId: string;
  label: string;
  /** 渲染高度（px），宽度按 logo 原始比例自适应 */
  size?: number;
  className?: string;
}

export function CompanyLogo({ companyId, label, size = 16, className = '' }: CompanyLogoProps) {
  const src = COMPANY_LOGO_SOURCES[companyId];

  if (!src) {
    return (
      <span
        style={{ width: size, height: size, fontSize: Math.max(9, Math.round(size * 0.6)) }}
        className={`inline-flex shrink-0 items-center justify-center rounded-full bg-light-hover font-semibold uppercase leading-none text-light-muted ${className}`}
        aria-hidden="true"
      >
        {label.trim().charAt(0) || '?'}
      </span>
    );
  }

  return (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      style={{ height: size }}
      className={`inline-block shrink-0 w-auto ${className}`}
      loading="lazy"
      decoding="async"
    />
  );
}
